import * as React from 'react';

interface WidgetProps {
  title: React.ReactNode;
  children: React.ReactNode;
  onRemove?: () => void;
  style?: React.CSSProperties;
  dragHandleProps?: React.HTMLAttributes<HTMLDivElement>;
}

export const Widget: React.FC<WidgetProps> = ({ title, children, onRemove, style = {}, dragHandleProps }) => (
  <div className="widget" style={style}>
    <div className="widget-header">
      <div className="widget-headerMain">
        <div className="widget-drag-handle" {...dragHandleProps} title="Drag to reorder" aria-label="Drag widget">
          <span className="widget-dragIcon" aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
          </span>
        </div>

        <div className="widget-titleWrap">
          <h4>{title}</h4>
        </div>
      </div>

      {onRemove && (
        <button onClick={onRemove} className="widget-remove" aria-label="Remove widget" type="button">
          <span aria-hidden="true">×</span>
        </button>
      )}
    </div>

    <div className="widget-content">{children}</div>
  </div>
);
